<div class="partial-compra-segura {{classCustom}}">
      <i [style.color]="color" class="material-icons">
            lock
      </i>
      <span>{{'Este ambiente é 100% seguro. Seus dados pessoais e seus dados de pagamento estarão protegidos e criptografados.' | translate}}</span>
</div>    